import { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { limitToFirst } from "firebase/database";
import {
  collection,
  endAt,
  getDocs,
  limit,
  orderBy,
  OrderByDirection,
  query,
  startAfter,
  startAt,
  where,
} from "firebase/firestore";
import { Alert } from "react-bootstrap";
import { db, storage } from "../../firebase/firebase";

export async function fetchData(options: {
  pageIndex: number;
  pageSize: number;
  documentList: any;
  lastPage: number;
  sorting: SortingState;
  lastsorting: SortingState;
  filter: ColumnFiltersState;
  lastFilter: ColumnFiltersState;
  isAdmin: boolean;
  group: string;
}) {
  var pageNr = options.pageIndex;
  var perPage = options.pageSize;
  var documentList = options.documentList;
  var lastPage = options.lastPage;
  var sorting = options.sorting;
  var lastsorting = options.lastsorting;
  var filter = options.filter;
  var lastFilter = options.lastFilter;
  var q;

  var group = options.group;
  var isAdmin = options.isAdmin;
  var queryConstraints = [];

  if (filter[0]?.value == " ") {
    filter[0].value = "";
  }

  if (filter != undefined) {
    if (lastFilter == undefined) {
      if (filter?.length != 0) {
        var filterType = filter[0]?.id;
        var filterString = filter[0]?.value;
        var orderby = "username";
        var orderdirection = "asc" as OrderByDirection;

        if (sorting.length != 0) {
          orderby = sorting[0]?.id;
          orderdirection = !sorting[0]?.desc
            ? "desc"
            : ("asc" as OrderByDirection);
        }

        if (!isAdmin) {
          queryConstraints.push(where("request.group", "==", group));
        }
        queryConstraints.push(
          where(filterType, ">=", filterString.toString().toLowerCase())
        );
        queryConstraints.push(
          where(
            filterType,
            "<=",
            filterString.toString().toLowerCase() + "\uf8ff"
          )
        );
        if (orderby != "mail") {
          queryConstraints.push(orderBy("mail"));
        }
        queryConstraints.push(orderBy(orderby, orderdirection));
        queryConstraints.push(limit(perPage));

        q = query(collection(db, "users"), ...queryConstraints);

        const querySnapshot = await getDocs(q);

        var help = [];
        var last = [];

        querySnapshot.forEach((doc) => {
          var data = doc.data();
          data.id = doc.id;
          last.push(doc);
          help.push(data);
        });

        var pageCount = -1;
        if (help.length < perPage) {
          pageCount = pageNr;
        }

        return {
          last: last,
          lastPage: pageNr,
          rows: help,
          pageCount: pageCount, //Math.ceil(help.length / options.pageSize),
          lastsorting: sorting,
          lastFilter: filter,
        };
      }
    } else if (
      filter[0]?.id != lastFilter[0]?.id ||
      filter[0]?.value != lastFilter[0]?.value
    ) {
      var filterType = filter[0]?.id;
      var filterString = filter[0]?.value;
      var orderby = "username";
      var orderdirection = "asc" as OrderByDirection;

      if (sorting.length != 0) {
        orderby = sorting[0]?.id;
        orderdirection = !sorting[0]?.desc
          ? "desc"
          : ("asc" as OrderByDirection);
      }

      queryConstraints.push(orderBy(filterType));
      if (!isAdmin) {
        queryConstraints.push(where("request.group", "==", group));
      }
      queryConstraints.push(
        filterType,
        ">=",
        filterString.toString().toLowerCase()
      );
      queryConstraints.push(
        filterType,
        "<=",
        filterString.toString().toLowerCase() + "\uf8ff"
      );
      queryConstraints.push(limit(perPage));

      q = query(collection(db, "users"), ...queryConstraints);

      const querySnapshot = await getDocs(q);

      var help = [];
      var last = [];

      querySnapshot.forEach((doc) => {
        var data = doc.data();
        data.id = doc.id;
        last.push(doc);
        help.push(data);
      });

      var pageCount = -1;
      if (help.length < perPage) {
        pageCount = pageNr;
      }

      return {
        last: last,
        lastPage: pageNr,
        rows: help,
        pageCount: pageCount, //Math.ceil(help.length / options.pageSize),
        lastsorting: sorting,
        lastFilter: filter,
      };
    }
  }

  if (
    lastsorting != undefined &&
    (sorting[0]?.id != lastsorting[0]?.id ||
      sorting[0]?.desc != lastsorting[0]?.desc)
  ) {
    var orderby = sorting[0]?.id;
    var orderdirection = !sorting[0]?.desc
      ? "desc"
      : ("asc" as OrderByDirection);

    if (!isAdmin) {
      queryConstraints.push(where("request.group", "==", group));
    }
    queryConstraints.push(orderBy(orderby, orderdirection));
    queryConstraints.push(limit(perPage));

    q = query(collection(db, "users"), ...queryConstraints);

    const querySnapshot = await getDocs(q);

    var help = [];
    var last = [];

    querySnapshot.forEach((doc) => {
      var data = doc.data();
      data.id = doc.id;
      last.push(doc);
      help.push(data);
    });

    var pageCount = -1;

    if (help.length < perPage) {
      pageCount = pageNr;
    }

    return {
      last: last,
      lastPage: pageNr,
      rows: help,
      pageCount: pageCount, //Math.ceil(help.length / options.pageSize),
      lastsorting: sorting,
      lastFilter: filter,
    };
  }

  if (lastPage == pageNr) {
    var helpData = [];

    documentList.forEach((doc) => {
      var data = doc.data();
      data.id = doc.id;
      helpData.push(data);
    });

    return {
      last: documentList,
      lastPage: pageNr,
      rows: helpData,
      pageCount: -1, //Math.ceil(help.length / options.pageSize),
      lastsorting: sorting,
      lastFilter: filter,
    };
  }

  if (documentList != undefined) {
    var orderby = "username";
    var orderdirection = "asc" as OrderByDirection;

    if (sorting.length != 0) {
      orderby = sorting[0]?.id;
      orderdirection = !sorting[0]?.desc ? "desc" : ("asc" as OrderByDirection);
    }

    if (!isAdmin) {
      queryConstraints.push(where("request.group", "==", group));
    }
    queryConstraints.push(orderBy(orderby, orderdirection));
    queryConstraints.push(startAfter(documentList[documentList.length - 1]));
    queryConstraints.push(limit(perPage));
    q = query(collection(db, "users"), ...queryConstraints);

  } else {
    try {
      if (!isAdmin) {
        queryConstraints.push(where("request.group", "==", group));
      }
      queryConstraints.push(orderBy("username"));
      queryConstraints.push(limit(perPage));
      q = query(collection(db, "users"), ...queryConstraints);
    } catch (error) {
      console.log("error::::");
      console.log(error);
    }
  }

  const querySnapshot = await getDocs(q);

  var help = [];
  var last = [];

  querySnapshot.forEach((doc) => {
    var data = doc.data();
    data.id = doc.id;
    last.push(doc);
    help.push(data);
  });

  var pageCount = -1;

  if (help.length < perPage) {
    pageCount = pageNr;
  }

  return {
    last: last,
    lastPage: pageNr,
    rows: help,
    pageCount: pageCount, //Math.ceil(help.length / options.pageSize),
    lastsorting: sorting,
    lastFilter: filter,
  };
}
